var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-discharging-trucking" },
    [
      _c(
        "tab-discharging-trucking-UICustom-layout",
        {
          staticStyle: { "min-width": "1200px" },
          attrs: { "element-blocks": _vm.elementBlocks }
        },
        [
          _c(
            "div",
            {
              staticClass: "section",
              attrs: { slot: "DoorToDoorLoading" },
              slot: "DoorToDoorLoading"
            },
            [
              _c(
                "span",
                { staticClass: "title" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("SeaExport.DoorToDoorLoading")) + " "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "red",
                        "font-weight": "lighter",
                        margin: "30px"
                      }
                    },
                    [
                      _vm._v(
                        "注：1、" +
                          _vm._s(
                            _vm.$t("SeaExport.SaveBusinessBeforeEnterMultiGate")
                          ) +
                          "；2、"
                      ),
                      _vm.job.dischargingPortDoor
                        ? _c("span", [
                            _vm._v(
                              "若需指定目的港运输公司，请维护运输公司字段，未维护时尾程商务会进行分配"
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  (_vm.job.lob === "SE" || _vm.job.lob === "AE") &&
                  _vm.readonly &&
                  _vm.showSync
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.exportSyncImport }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Synchronization")))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.multipleDischargingPickups,
                          expression: "job.multipleDischargingPickups"
                        }
                      ]
                    },
                    [
                      _vm.top.visible
                        ? _c("cargo-ag-grid", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "1",
                              "config-module": _vm.topConfigModuel,
                              "grid-options": _vm.top.gridOptions,
                              "column-defs": _vm.topColumnDefs,
                              "row-data": _vm.trucking
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.topGridApi = params.api
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  !_vm.isMaster && _vm.job.multipleDischargingPickups
                    ? _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row operations",
                          staticStyle: { padding: "5px 0" }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cooperateEdit,
                                  expression: "cooperateEdit"
                                }
                              ],
                              staticClass: "triggers"
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "2",
                                        type: "primary",
                                        disabled: _vm.readonly || !_vm.addEnable
                                      },
                                      on: { click: _vm.copyNewHandler }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.copyAndAddPoItems")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "3",
                                        type: "primary",
                                        disabled: _vm.readonly || !_vm.addEnable
                                      },
                                      on: { click: _vm.addHandler }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "4",
                                        type: "danger",
                                        disabled: _vm.readonly
                                      },
                                      on: { click: _vm.delHandler }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          [
            _vm.elementDict.multipleDischargingPickups.viewable
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "multipleDischargingPickups" },
                    slot: "multipleDischargingPickups"
                  },
                  [
                    _c(
                      "template",
                      { slot: "label" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              no: "5.1",
                              disabled: _vm.readonly || _vm.action === "add"
                            },
                            on: { change: _vm.multiPickupsChangeHandler },
                            model: {
                              value: _vm.job.multipleDischargingPickups,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.job,
                                  "multipleDischargingPickups",
                                  $$v
                                )
                              },
                              expression: "job.multipleDischargingPickups"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.elementDict.multipleDischargingPickups
                                    .label
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm.elementDict.quantity.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "quantity" }, slot: "quantity" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.quantity.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.quantity.label
                      },
                      slot: "label"
                    }),
                    _c("el-input-number", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "6",
                        value: _vm.truckingInfo.quantity || undefined,
                        disabled: _vm.readonly,
                        min: 0,
                        max: 99999,
                        precision: 0,
                        "controls-position": "right"
                      },
                      on: {
                        input: function(val) {
                          _vm.truckingInfo.quantity = val
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.weight.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "weight" }, slot: "weight" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.weight.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.weight.label
                      },
                      slot: "label"
                    }),
                    _c("el-input-number", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "7",
                        value: _vm.truckingInfo.weight || undefined,
                        disabled: _vm.readonly,
                        min: 0,
                        max: 99999,
                        precision: 3,
                        "controls-position": "right"
                      },
                      on: {
                        input: function(val) {
                          _vm.truckingInfo.weight = val
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cubage.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "cubage" }, slot: "cubage" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.cubage.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.cubage.label
                      },
                      slot: "label"
                    }),
                    _c("el-input-number", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "8",
                        value: _vm.truckingInfo.cubage || undefined,
                        disabled: _vm.readonly,
                        min: 0,
                        max: 99999,
                        precision: 3,
                        "controls-position": "right"
                      },
                      on: {
                        input: function(val) {
                          _vm.truckingInfo.cubage = val
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.carryingCmp.viewable && !_vm.isSalesForSzfs
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "carryingCmp" },
                    slot: "carryingCmp"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.carryingCmp.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.carryingCmp.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-company-select", {
                      staticStyle: { width: "400px", display: "inline-block" },
                      attrs: {
                        no: "9",
                        disabled: _vm.readonly,
                        "method-params": { truckCmp: true, active: true },
                        "default-value": _vm.truckingInfo.carryingCmp || ""
                      },
                      on: {
                        change: function(p) {
                          _vm.truckingInfo.carryingCmp = p.value || 0
                          _vm.carryingCmpChangeHandler()
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.driver.viewable && !_vm.isSalesForSzfs
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "driver" },
                    slot: "driver"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.driver.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.driver.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "400px" },
                        attrs: {
                          disabled: _vm.readonly,
                          no: "10",
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                          "allow-create": true,
                          clearable: true,
                          filterable: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.carryingContactsChangeHandler(
                              false,
                              false
                            )
                          },
                          blur: _vm.selectContactBlur
                        },
                        model: {
                          value: _vm.truckingInfo.driver,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "driver", $$v)
                          },
                          expression: "truckingInfo.driver"
                        }
                      },
                      _vm._l(_vm.carryingContacts, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: item.contactPerson,
                            value: item.contactPerson
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.loadingDate.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "loadingDate" },
                    slot: "loadingDate"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.loadingDate.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.loadingDate.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      ref: "loadingDate",
                      staticStyle: { width: "400px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "11",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm:ss"
                      },
                      on: {
                        blur: function() {
                          _vm.handleBlur(
                            "loadingDate",
                            null,
                            true,
                            true,
                            _vm.truckingInfo
                          )
                        }
                      },
                      model: {
                        value: _vm.truckingInfo.loadingDate,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "loadingDate", $$v)
                        },
                        expression: "truckingInfo.loadingDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.driverName.viewable && !_vm.isSalesForSzfs
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "driverName", disabled: _vm.txtEditEable },
                    slot: "driverName"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.driverName.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.driverName.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { disabled: _vm.readonly, no: "12" },
                      model: {
                        value: _vm.truckingInfo.driverName,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "driverName", $$v)
                        },
                        expression: "truckingInfo.driverName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.travelTime.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "travelTime" },
                    slot: "travelTime"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.travelTime.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.travelTime.label
                      },
                      slot: "label"
                    }),
                    _c("el-input-number", {
                      staticStyle: { width: "155px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "13",
                        min: 0,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.truckingInfo.travelHour,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "travelHour", $$v)
                        },
                        expression: "truckingInfo.travelHour"
                      }
                    }),
                    _c("span", { staticStyle: { margin: "10px" } }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Hour")))
                    ]),
                    _c("el-input-number", {
                      staticStyle: { width: "155px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "14",
                        min: 0,
                        max: 59,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.truckingInfo.travelMinute,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "travelMinute", $$v)
                        },
                        expression: "truckingInfo.travelMinute"
                      }
                    }),
                    _c("span", { staticStyle: { margin: "10px" } }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Minute")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.doorMan.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "doorMan" },
                    slot: "doorMan"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.doorMan.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.doorMan.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { disabled: _vm.readonly, no: "15" },
                      model: {
                        value: _vm.truckingInfo.doorMan,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                        },
                        expression: "truckingInfo.doorMan"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.doorAddr.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "doorAddr" },
                    slot: "doorAddr"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.doorAddr.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.doorAddr.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "16",
                        type: "textarea",
                        rows: 3
                      },
                      model: {
                        value: _vm.truckingInfo.doorAddr,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                        },
                        expression: "truckingInfo.doorAddr"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.zipCode.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "zipCode" },
                    slot: "zipCode"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.zipCode.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.zipCode.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { disabled: _vm.readonly, no: "zipCode" },
                      model: {
                        value: _vm.truckingInfo.zipCode,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "zipCode", $$v)
                        },
                        expression: "truckingInfo.zipCode"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cityCode.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { slot: "cityCode" },
                    slot: "cityCode"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.cityCode.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.cityCode.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "17",
                        disabled: _vm.readonly,
                        "tag-name":
                          _vm.$store.getters.language === "zh"
                            ? "chineseName"
                            : "englishName",
                        "tag-value": "code",
                        cache: false,
                        filterable: "",
                        "default-value": _vm.truckingInfo.cityCode,
                        "static-options": _vm.cityList,
                        placeholder: _vm.$t("SeaExport.PleaseSelect")
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.truckingInfo.cityCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.po.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "po" }, slot: "po" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.po.isRequire ? "blue" : "",
                      attrs: { slot: "label", label: _vm.elementDict.po.label },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "po",
                        disabled: _vm.readonly,
                        "filter-chars": false,
                        type: "textarea",
                        rows: 3
                      },
                      model: {
                        value: _vm.truckingInfo.po,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "po", $$v)
                        },
                        expression: "truckingInfo.po"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.exChangeAgent.viewable && !_vm.isSalesForSzfs
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "exChangeAgent" }, slot: "exChangeAgent" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.exChangeAgent.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.exChangeAgent.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-company-select", {
                      staticStyle: { width: "400px", display: "inline-block" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "exChangeAgent",
                        "method-params": { bookingAgent: true, active: true },
                        "default-value": _vm.truckingInfo.exChangeAgent || ""
                      },
                      on: { change: _vm.onExChangeAgentChange }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          [
            _vm.elementDict.soNo.viewable && _vm.job.multipleDischargingPickups
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "soNo", "label-width": "100px" },
                    slot: "soNo"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.soNo.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.soNo.label
                      },
                      slot: "label"
                    }),
                    _c("so-no-selector", {
                      staticStyle: { width: "400px" },
                      attrs: { "so-no": _vm.soNo, disabled: _vm.readonly },
                      model: {
                        value: _vm.truckingInfo.soNo,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "soNo", $$v)
                        },
                        expression: "truckingInfo.soNo"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.truckOrderNo.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "truckOrderNo" },
                    slot: "truckOrderNo"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.truckOrderNo.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.truckOrderNo.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "19",
                        disabled: _vm.readonly || !!_vm.truckingInfo.carFormUuid
                      },
                      on: {
                        change: function($event) {
                          _vm.checkTruckOrderNo()
                          _vm.refreshTopGrid()
                        }
                      },
                      model: {
                        value: _vm.truckingInfo.truckOrderNo,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "truckOrderNo", $$v)
                        },
                        expression: "truckingInfo.truckOrderNo"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.truckingFee.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "truckingFee" },
                    slot: "truckingFee"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.truckingFee.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.truckingFee.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "118px", "flex-grow": "1" },
                          attrs: {
                            no: "40",
                            value: _vm.truckingInfo.truckingFee,
                            disabled: _vm.readonly,
                            min: 0,
                            max: 999999999999,
                            precision: 2,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(value) {
                              _vm.truckingFeeCharge(value || 0)
                            }
                          }
                        }),
                        _c("cargo-advance-select", {
                          staticStyle: { width: "118px", "margin-left": "5px" },
                          attrs: {
                            no: "currency",
                            disabled: _vm.readonly,
                            "select-type": _vm.TYPE_NAMES.basic_data_Currency,
                            filterable: "",
                            clearable: false,
                            "default-value": _vm.truckingInfo.currency
                          },
                          on: { parentCallBack: _vm.onCurrencyChange }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.destinationPortAdditionalFee &&
            _vm.elementDict.destinationPortAdditionalFee.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "destinationPortAdditionalFee" },
                    slot: "destinationPortAdditionalFee"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.destinationPortAdditionalFee
                        .isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label:
                          _vm.elementDict.destinationPortAdditionalFee.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "destinationPortAdditionalFee",
                        disabled: _vm.readonly,
                        type: "textarea",
                        rows: 3
                      },
                      model: {
                        value: _vm.truckingInfo.destinationPortAdditionalFee,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.truckingInfo,
                            "destinationPortAdditionalFee",
                            $$v
                          )
                        },
                        expression: "truckingInfo.destinationPortAdditionalFee"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.driverTel.viewable && !_vm.isSalesForSzfs
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "driverTel" },
                    slot: "driverTel"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.driverTel.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.driverTel.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { no: "41", disabled: _vm.readonly },
                      on: { change: _vm.refreshTopGrid },
                      model: {
                        value: _vm.truckingInfo.driverTel,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "driverTel", $$v)
                        },
                        expression: "truckingInfo.driverTel"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.actLoadingDate.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "actLoadingDate" },
                    slot: "actLoadingDate"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.actLoadingDate.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.actLoadingDate.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      ref: "actLoadingDate",
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "42",
                        disabled: _vm.readonly,
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm:ss"
                      },
                      on: {
                        blur: function() {
                          _vm.handleBlur(
                            "actLoadingDate",
                            null,
                            true,
                            true,
                            _vm.truckingInfo
                          )
                        }
                      },
                      model: {
                        value: _vm.truckingInfo.actLoadingDate,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "actLoadingDate", $$v)
                        },
                        expression: "truckingInfo.actLoadingDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.plateNumber.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "plateNumber" },
                    slot: "plateNumber"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.plateNumber.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.plateNumber.label
                      },
                      slot: "label"
                    }),
                    _vm.isEdit
                      ? _c("el-input", {
                          staticStyle: { width: "280px" },
                          attrs: { no: "43" },
                          on: {
                            input: function(val) {
                              _vm.truckingInfo.plateNumber = val.trim()
                            }
                          },
                          model: {
                            value: _vm.truckingInfo.plateNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "plateNumber", $$v)
                            },
                            expression: "truckingInfo.plateNumber"
                          }
                        })
                      : _vm._e(),
                    _vm.readonly
                      ? _c("span", { staticClass: "plate_number" }, [
                          _vm._v(_vm._s(_vm.truckingInfo.plateNumber))
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.driverPhone.viewable && !_vm.isSalesForSzfs
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "driverPhone", disabled: _vm.txtEditEable },
                    slot: "driverPhone"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.driverPhone.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.driverPhone.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { no: "45", disabled: _vm.readonly },
                      model: {
                        value: _vm.truckingInfo.driverPhone,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "driverPhone", $$v)
                        },
                        expression: "truckingInfo.driverPhone"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.doorName.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "doorName" },
                    slot: "doorName"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.doorName.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.doorName.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-repeat-value-select", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        placeholder: _vm.readonly
                          ? ""
                          : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                        filterable: "",
                        "allow-create": true,
                        disabled: _vm.readonly,
                        clearable: "",
                        options: _vm.doorList,
                        "label-field": "name",
                        "value-field": "name",
                        "unique-field": "uuid",
                        "match-of-repeat-value": _vm.matchOfRepeatDoor
                      },
                      on: { change: _vm.doorsChangeHandler },
                      model: {
                        value: _vm.truckingInfo.doorName,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "doorName", $$v)
                        },
                        expression: "truckingInfo.doorName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.doorManTel.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "doorManTel" },
                    slot: "doorManTel"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.doorManTel.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.doorManTel.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { no: "46", disabled: _vm.readonly },
                      model: {
                        value: _vm.truckingInfo.doorManTel,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                        },
                        expression: "truckingInfo.doorManTel"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.remarks.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "remarks" }, slot: "remarks" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.remarks.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "47",
                        disabled: _vm.readonly,
                        "filter-chars": false,
                        type: "textarea",
                        rows: 3
                      },
                      model: {
                        value: _vm.truckingInfo.remarks,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "remarks", $$v)
                        },
                        expression: "truckingInfo.remarks"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.palletSum.viewable
              ? _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { slot: "palletSum" },
                    slot: "palletSum"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.palletSum.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.palletSum.label
                      },
                      slot: "label"
                    }),
                    _c("el-input-number", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "18",
                        value: _vm.truckingInfo.palletSum,
                        disabled: _vm.readonly,
                        min: 0,
                        max: 999999999999,
                        precision: 0,
                        controls: false
                      },
                      on: {
                        input: function(val) {
                          _vm.truckingInfo.palletSum = val || 0
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.palletDetail &&
            _vm.elementDict.palletDetail.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "palletDetail" }, slot: "palletDetail" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.palletDetail.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.palletDetail.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-textarea", {
                      attrs: {
                        no: "agentInformation",
                        type: "textarea",
                        row: 3,
                        disabled: _vm.readonly
                      },
                      model: {
                        value: _vm.truckingInfo.palletDetail,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "palletDetail", $$v)
                        },
                        expression: "truckingInfo.palletDetail"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.palletSize && _vm.elementDict.palletSize.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "palletSize" }, slot: "palletSize" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.palletSize.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.palletSize.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-textarea", {
                      attrs: {
                        no: "agentInformation",
                        type: "textarea",
                        row: 3,
                        disabled: _vm.readonly
                      },
                      model: {
                        value: _vm.truckingInfo.palletSize,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "palletSize", $$v)
                        },
                        expression: "truckingInfo.palletSize"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.dischargingWay.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "dischargingWay" }, slot: "dischargingWay" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.dischargingWay.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.dischargingWay.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "400px" },
                        attrs: {
                          value: _vm.truckingInfo.dischargingWay
                            ? _vm.truckingInfo.dischargingWay.split(",")
                            : [],
                          no: "48",
                          disabled: _vm.readonly,
                          multiple: ""
                        },
                        on: {
                          input: function(value) {
                            _vm.truckingInfo.dischargingWay = value.join(",")
                          }
                        }
                      },
                      [
                        _c("el-option", { attrs: { value: "DROP" } }),
                        _c("el-option", { attrs: { value: "LIVE UNLOAD" } }),
                        _c("el-option", {
                          attrs: { value: "EXCHANGE PALLETS" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.actDeliveryDate.viewable
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "actDeliveryDate" },
                    slot: "actDeliveryDate"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.actDeliveryDate.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.actDeliveryDate.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      ref: "actDeliveryDate",
                      staticStyle: { width: "400px" },
                      attrs: {
                        no: "actDeliveryDate",
                        disabled: _vm.readonly,
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm:ss"
                      },
                      on: {
                        blur: function() {
                          _vm.handleBlur(
                            "actDeliveryDate",
                            null,
                            true,
                            true,
                            _vm.truckingInfo
                          )
                        }
                      },
                      model: {
                        value: _vm.truckingInfo.actDeliveryDate,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "actDeliveryDate", $$v)
                        },
                        expression: "truckingInfo.actDeliveryDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.boxesNumber.viewable
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "boxesNumber" }, slot: "boxesNumber" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.boxesNumber.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.boxesNumber.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { type: "text", no: "61", disabled: _vm.readonly },
                      on: {
                        input: function($event) {
                          _vm.truckingInfo.boxesNumber = _vm.truckingInfo.boxesNumber.replace(
                            /[^0-9]/g,
                            ""
                          )
                        }
                      },
                      model: {
                        value: _vm.truckingInfo.boxesNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "boxesNumber", $$v)
                        },
                        expression: "truckingInfo.boxesNumber"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pageSource !== "remoteBooking",
                  expression: "pageSource !== 'remoteBooking'"
                }
              ],
              staticClass: "section",
              attrs: { slot: "containerInfo2" },
              slot: "containerInfo2"
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
              ]),
              !_vm.isMaster
                ? _c("div", { staticClass: "app-main-inner-row operations" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cooperateEdit,
                            expression: "cooperateEdit"
                          }
                        ],
                        staticClass: "triggers"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "48",
                                  type: "primary",
                                  disabled: !_vm.linkUsageEnable
                                },
                                on: { click: _vm.linkUsageClickHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AddPackingInfo"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "49",
                                  type: "danger",
                                  disabled: !_vm.linkUsageEnable
                                },
                                on: { click: _vm.delLinkUsageClickHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.RemovePackingInfo"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticStyle: { "flex-grow": "1", padding: "10px" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "350px" },
                    attrs: {
                      no: "52",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.usages
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        2
      ),
      _c("discharging-trucking-container-usage-link-dialog", {
        attrs: {
          visible: _vm.containerUsageDialog.visible,
          "job-uuid": _vm.job.uuid,
          "trucking-info-uuid": _vm.truckingInfo.uuid,
          "serial-nos": _vm.containerUsageDialog.serialNos
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.containerUsageDialog, "visible", $event)
          },
          selectContainerUsageHandler: _vm.selectContainerUsageHandler
        }
      }),
      _c("upload-common-file", {
        attrs: {
          visible: _vm.uploadCommonFileDialog.visible,
          model: _vm.uploadCommonFileDialog.model
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadCommonFileDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }